import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Subheading from "../Common/Subheading";
import CustomersIcon from "../../assets/icons/customers.svg2";
import ManageUsers from "./ManageUsers";
import ManageUsersRoles from "./ManageUsersRoles";
import AddUsersModal from "./AddUsersModal";
import HelpButton from "../HelpContent/HelpButton";
import { isUserPermitted } from "../helpers/pageProps";

function UsersSettings() {
  const location = useLocation();
  const navigate = useNavigate();
  const [userCollapsed, setUserCollapsed] = useState(false);
  const [roleCollapsed, setRoleCollapsed] = useState(true);
  return (
    <div className="mb-5">
      <Subheading
        Icon={CustomersIcon}
        heading="Users Settings"
        subheading="User settings and user system controls ."
      />
      {isUserPermitted("view_user") && (
        <div className="my-3">
          <AddUsersModal
            autoOpen={location.state?.openAddUser}
            hideButton
            onClose={() => navigate("/settings/users", { replace: true })}
          />
          <ManageUsers
            collapsed={userCollapsed}
            setCollapsed={() => {
              setUserCollapsed(!userCollapsed);
              if (userCollapsed) {
                setRoleCollapsed(true);
              }
            }}
          />
        </div>
      )}
      {isUserPermitted("view_permissions") && (
        <div className="my-3">
          <ManageUsersRoles
            collapsed={roleCollapsed}
            setCollapsed={() => {
              setRoleCollapsed(!roleCollapsed);
              if (roleCollapsed) {
                setUserCollapsed(true);
              }
            }}
          />
        </div>
      )}
    </div>
  );
}

export default UsersSettings;
